// 分级树形选择组件
import treeSelector from './tree'

export default treeSelector
